// Resample one or more channels of Float32 PCM to a new sample rate, via the
// browser's own OfflineAudioContext — the same quality-resampling trick
// decodeAudio.js uses for Whisper, generalised to arbitrary channel counts.

export async function resampleChannels(channels, fromRate, toRate) {
  if (!channels.length || fromRate === toRate) return channels;

  const numChannels = channels.length;
  const numFrames = channels[0].length;
  const OfflineCtx = window.OfflineAudioContext || window.webkitOfflineAudioContext;
  const outFrames = Math.max(1, Math.ceil((numFrames * toRate) / fromRate));

  const offline = new OfflineCtx(numChannels, outFrames, toRate);
  const buffer = offline.createBuffer(numChannels, numFrames, fromRate);
  for (let c = 0; c < numChannels; c++) buffer.copyToChannel(channels[c], c);

  const src = offline.createBufferSource();
  src.buffer = buffer;
  src.connect(offline.destination);
  src.start(0);

  const rendered = await offline.startRendering();
  const out = [];
  for (let c = 0; c < numChannels; c++) out.push(rendered.getChannelData(c).slice());
  return out;
}
